import React from 'react'
import './LibraryChapter.css'
import { IP } from '../../../../internalServer'

export default function LibraryChapter(props) {
  return (
    <div>
      <div className='d-flex gap-2 align-items-center chapter_total_library m-3 p-3'>
        <div className="chapterNoCOntainer">
          {/* <h2 className="chapterNo">{props.chapterNo+1}</h2> */}
          <img
            // src={
            //   props.books[props.indexOfBook].thumbnailImage
            //     ? IP + props.books[props.indexOfBook].thumbnailImage.replace(/^\./, "")
            //     : "/LibraryImg/LibrarySubjectImg.svg "
            // }
            src='/images/Chapter_XS.png'
            className="imageSizeChapter"
            alt="Book img"
          ></img>
        </div>
        <div >
          <div className='chapterno_library'>{props.chapterName}</div>
          <div className='studyMaterial'>{props.StudyMaterial}</div>
          <div className='studyMaterialProgrss'>{props.Progress}</div>
        </div>
      </div>
    </div>
  )
}
